module.exports = __webpack_public_path__ + "static/media/bracket.378e1cbb.svg";